/*
 * HomePage
 *
 * This is the first thing users see of our App, at the '/' route
 */

/* eslint-disable no-nested-ternary */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import isEqual from 'lodash/isEqual';
import { useScreenDetector } from '../../components/custom-hooks/screen-detector';

import injectReducer from '../../utils/injectReducer';
import injectSaga from '../../utils/injectSaga';
import { checkout, editDiscountCode, removeDiscountCode } from './actions';
import reducer from './reducer';
import saga from './saga';
import makeSelectHome from './selectors';
import {
  expandFloatingOffer,
  // isPresentInCart,
  setPrimaryForFloating,
} from '../../../floating';
import makeSelectGlobal from '../../selector';
import {
  EventActionAdd,
  EventActionATC,
  EventActionBack,
  EventActionBuynow,
  EventActionCheckout,
  EventActionClose,
  EventActionFloating,
  EventActionIncrease,
  EventActionMinimize,
  EventActionOffer,
  EventActionOpen,
  EventActionSelect,
  EventActionSkip,
  EventNameDealExpired,
  EventNameOfferButtonClick,
  EventNameOfferPageLaunch,
  EventNameOfferProductPage,
  EventNameProductButtonClick,
  EventNameQuantityChange,
  EventVariableDefault,
  EventVariableRepeat,
  EventVariableVariant,
  getEventConstants,
} from '../../../eventsHelper';
import makeSelectInit from '../Init/selectors';
import {
  sendEvent,
  addToCart,
  balanceProductAddtions,
  commonFunction,
} from '../Init/actions';
import {
  _compareCartAndAddProductAdditions,
  _getAddedVariantsToDisplay,
  _getAddedVariantTitleFromCart,
  _getLastAddedVariant,
  _getLastAddition,
  _getProductAddtionsByProductIndex,
  _getProductQuantity,
  _getTotalQuantity,
  _getVariantQuantity,
  _getVariantQuantityFromCart,
  _isMaximumProductsAdded,
  _isOfferedProductsRestrictedAndAdded,
  _isCurrProductSelectedInRestrictedOfferedProducts,
  _isPrimaryAndOfferedSame,
  _onAddClick,
} from '../../../productHelper';
import Popup from '../../components/Popup';
import {
  addOfferedVariantsToCart,
  addVariantsWithQuantityToCart,
  changeCart,
  fetchCart,
  getMonkDiscountProperties,
  getMRCartFromShopifyCart,
} from '../../../common/cart';
import { goToCart, goToProductPage } from '../../../common/navigation';
import {
  getMrDiscountCode,
  setDisabledProductID,
  setFloating,
  setFloatingInDisplay,
  getDiscountCodeFromApps,
} from '../../../common/settings';
import {
  changeCartAndContinue,
  renderInDiv,
} from '../../../features/popupModule';
import {
  getShop,
  // isInaEss
} from '../../../common/pageData';
import { logger } from '../../../common/logger';

import FloatingButton from '../../components/molecules/FloatingButton';
import Dialog from '../../components/atoms/Dialog';
import {
  fadeInUp,
  fadeOutDown,
  slideInUp,
  slideOutRight,
  slideInLeft,
  slideOutDown,
} from '../../components/transitions';
import { roundOff } from '../../components/helpers/float';
import { reloadPage } from '../../../pageHelper';
import { pdpPopupTriggers } from './constants';

/* eslint-disable react/prefer-stateless-function */
export class HomePage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.displayRepeatSelection = this.displayRepeatSelection.bind(this);
    this.onClickChoose = this.onClickChoose.bind(this);
    this.onClickRepeat = this.onClickRepeat.bind(this);
    this.toggleShowDescription = this.toggleShowDescription.bind(this);
    this.onSelectVariant = this.onSelectVariant.bind(this);
    this.addToCartFromDescriptionPage = this.addToCartFromDescriptionPage.bind(
      this,
    );
    this.onCheckout = this.onCheckout.bind(this);
    this.closeAll = this.closeAll.bind(this);
    this.compareCartAndAddProductAdditions = this.compareCartAndAddProductAdditions.bind(
      this,
    );
    this.onCheckoutClick = this.onCheckoutClick.bind(this);
    this.onMinimizeClick = this.onMinimizeClick.bind(this);
    this.getAddedProductsForEvent = this.getAddedProductsForEvent.bind(this);
    this.productEvent = this.productEvent.bind(this);
    this.closeFloating = this.closeFloating.bind(this);
    this.addToCart = this.addToCart.bind(this);
    this.onProductImageClick = this.onProductImageClick.bind(this);
    this.onProductTitleClick = this.onProductTitleClick.bind(this);
    this.productClickRedirectionHandler = this.productClickRedirectionHandler.bind(
      this,
    );
    this.getIsPdpPopupTrigger = this.getIsPdpPopupTrigger.bind(this);
  }

  state = {
    open: false,
    timer: 0,
    expand: true,
    repeatSelectionIndex: 0,
    repeatSelection: false,
    repeatProductAddtion: {},
    showProductDesciption: false,
    productDescriptionIndex: 0,
    isMinimizedOnce: false,
    selectedVariantInfo: [],
    discountCodeExpanded: false,
    middleConEleScrollTop: 0,
    isBottomBarButtonActionLoading: false,
    isCurrProductSelectedInRestrictedOfferedProductsResult: -1,
  }; // isExpanded: false, // dialog: false,

  // isUserSelected is set when a user selects the variant,
  // this is added to identify default selection of variant.
  onSelectVariant(idx, variant, isUserSelected) {
    const { showProductDesciption, selectedVariantInfo } = this.state;
    const { primary, products } = this.props;
    // maintain selected variant for all products
    const newSelectedVariantInfo = [...selectedVariantInfo];
    newSelectedVariantInfo[idx] = variant;
    this.setState({
      selectedVariantInfo: newSelectedVariantInfo,
    });

    if (isUserSelected) {
      const eventProductID = this.getProductIDFromVariantID(
        products,
        variant.id,
      );
      this.props.sendEvent({
        name: EventNameProductButtonClick,
        action: EventActionSelect,
        primary,
        added: [],
        offered: products,
        variables: [
          {
            name: 'page',
            value: showProductDesciption ? 'product' : 'offer',
          },
          {
            name: 'type',
            value: 'variant',
          },
          {
            name: 'sp_product_id',
            value: eventProductID.toString(),
          },
          {
            name: 'sp_variant_id',
            value: variant.id.toString(),
          },
        ],
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      products: prevProducts,
      primary: prevPrimary,
      eventID: prevEventID,
      cart: oldCart,
      init: { productAdditions: prevProductAdditions },
    } = prevProps;

    const {
      products,
      timer,
      primary,
      trigger,
      eventID,
      cart,
      open,
      expand,
      floatingDisabled,
      init: { productAdditions },
    } = this.props;
    const productAdditionsToUse = productAdditions.default || [];
    const prevProductAdditionsToUse = prevProductAdditions.default || [];

    if (
      JSON.stringify(productAdditionsToUse) !==
      JSON.stringify(prevProductAdditionsToUse)
    ) {
      this.isCurrProductSelectedInRestrictedOfferedProducts();
    }

    const { open: stateOpen, expand: stateExpand } = this.state;
    const { open: oldStateOpen, expand: oldStateExpand } = prevState;

    if (stateExpand !== oldStateExpand) {
      if (stateExpand && stateOpen) {
        document.querySelector('html').style.overflow = 'hidden';
        document.querySelector('body').style.overflow = 'hidden';
      } else {
        document.querySelector('html').style.overflow = 'auto';
        document.querySelector('body').style.overflow = 'auto';
      }
    }

    // expansion or launch of offer page
    if (oldStateOpen === false && stateOpen === true && stateExpand == true) {
      this.props.sendEvent({
        name: EventNameOfferPageLaunch,
        primary,
        action: oldStateExpand
          ? trigger === 'atc'
            ? EventActionATC
            : trigger === 'bn'
              ? EventActionBuynow
              : EventActionCheckout
          : EventActionFloating,
        offered: products,
      });
    }

    // scenario for floating closed and we have to open
    if (
      prevEventID != eventID &&
      stateOpen === false &&
      stateExpand === true &&
      open == true &&
      expand == true
    ) {
      // new trigger //state was closed // not expanded
      // floating set and primary product as well
      if (!floatingDisabled) {
        setFloating(true);
      }
      setPrimaryForFloating(primary);

      this.setState(
        {
          open: true,
          expand: true,
          timer,
        },
        () => {
          this.compareCartAndAddProductAdditions();
        },
      );
      return;
    }

    // condition to close the popup
    if (open == false && expand == true) {
      this.setState({ open: false, expand: true });
      return;
    }

    // if primary product has changed then set it
    if (prevPrimary.sp_product_id !== primary.sp_product_id) {
      setPrimaryForFloating(primary);
    }

    const prevIDs = prevProducts.reduce((acc, curr) => acc.concat(curr.id), []);

    const currIDs = products.reduce((acc, curr) => acc.concat(curr.id), []);

    prevIDs.sort();
    currIDs.sort();

    // if products are equal then no need to change any props
    if (isEqual(prevIDs, currIDs)) {
      // if cart is not equal then change
      // if the popup is expanded then change
      if (
        this.isCartEqual(oldCart, cart) === false ||
        (oldStateExpand !== stateExpand && stateExpand === true)
      ) {
        this.compareCartAndAddProductAdditions();
      }
      return;
    }
    if (!floatingDisabled) {
      setFloating(true);
    }

    this.setState(
      {
        open: true,
        expand: true,
        timer,
      },
      () => {
        this.compareCartAndAddProductAdditions();
      },
    );
  }

  isCartEqual(oldCart, newCart) {
    if (oldCart.length !== newCart.length) {
      return false;
    }

    for (let i = 0; i < oldCart.length; i++) {
      if (oldCart[i].sp_product_id !== newCart[i].sp_product_id) {
        return false;
      }

      if (oldCart[i].sp_variant_id !== newCart[i].sp_variant_id) {
        return false;
      }

      if (oldCart[i].quantity !== newCart[i].quantity) {
        return false;
      }
    }
    return true;
  }

  getMinutesAndSeconds(timer) {
    const minutes = Math.floor(timer / 60);
    const seconds = timer - minutes * 60;
    return { minutes, seconds };
  }

  componentDidMount() {
    const {
      products,
      open,
      expand,
      primary,
      timer,
      floatingDisabled,
    } = this.props;
    setPrimaryForFloating(primary);
    if (!floatingDisabled) {
      setFloating(true);
    }

    const selectedVariantInfo = products.reduce(
      (acc, curr, idx) => acc.concat(products[idx].variants[0]),
      [],
    );

    this.setState(
      {
        open,
        expand,
        timer,
        selectedVariantInfo,
      },
      () => {
        this.compareCartAndAddProductAdditions();
      },
    );

    // this.handlePopup();
    this.myInterval = setInterval(() => {
      const { timer, expand } = this.state;
      const { isTimerDisabled } = this.props;
      if (isTimerDisabled) {
        return;
      }

      // close the popup if timer exceeds and popup or floating is open
      if (timer <= 0) {
        if (timer === 0) {
          // if the popup is expanded then the action would be offer else it would be floating
          this.props.sendEvent({
            name: EventNameDealExpired,
            primary,
            action: expand ? EventActionOffer : EventActionFloating,
            offered: products,
          });
        }
        this.closeAll();
      }
      this.setState({ timer: timer - 1 });
    }, 1000);

    if (expand) {
      document.querySelector('html').style.overflow = 'hidden';
      document.querySelector('body').style.overflow = 'hidden';
    } else {
      document.querySelector('html').style.overflow = 'auto';
      document.querySelector('body').style.overflow = 'auto';
    }

    this.isCurrProductSelectedInRestrictedOfferedProducts();
  }

  compareCartAndAddProductAdditions() {
    const productAdditions = this.props.init.productAdditions.default || [];
    const { products, cart, balanceProductAddtions } = this.props;
    _compareCartAndAddProductAdditions({
      productAdditions,
      products,
      cart,
      getVariantQuantityFromCart: _getVariantQuantityFromCart,
      getVariantQuantity: _getVariantQuantity,
      balanceProductAddtions,
    });

    // const balance = [];
    // products.map((product) => {
    //   return product.variants.map((variant) => {
    //     const cartQuantity = this.getVariantQuantityFromCart(cart, variant.id);
    //     const addedQuantity = this.getVariantQuantity(
    //       productAdditions,
    //       variant.id
    //     );

    //     if (cartQuantity === addedQuantity) {
    //       return;
    //     }
    //     return balance.push({
    //       product_id: product.id,
    //       variant_id: variant.id,
    //       quantity: cartQuantity - addedQuantity,
    //       variant_title: variant.title,
    //     });
    //   });
    // });

    // if (balance.length > 0) {
    //   this.props.balanceProductAddtions(balance);
    // }
  }

  handlePopup = () => {
    this.setState({ open: !this.state.open });
  };

  closeRepeatSelection = () => {
    this.setState({
      repeatSelection: !this.state.repeatSelection,
      repeatProductAddtion: {},
      repeatSelectionIndex: 0,
    });
  };

  skipAndContinue = async () => {
    const {
      trigger,
      products,
      primary,
      event,
      variantsWithOldQuantity,
      floatingDisabled,
      home: {
        discountCode: { code },
      },
      theme,
      checkoutOnSkip,
      offerType,
    } = this.props;
    const { showProductDesciption, isMinimizedOnce } = this.state;
    const added = this.getAddedProductsForEvent();
    this.props.sendEvent({
      name: EventNameOfferButtonClick,
      action: EventActionSkip,
      primary,
      added,
      offered: products,
      variables: [
        {
          name: 'page',
          value: showProductDesciption ? 'product' : 'offer',
        },
      ],
    });

    if (trigger === 'bn') {
      setDisabledProductID(this.props.primary.sp_product_id);
      // this.onCheckout();
      // return;
    }

    let reload = true;
    // don't reload in case of add to cart trigger as event has to be continued
    if (trigger === 'atc') {
      reload = false;
    }

    // for checkout click offers, if skip is clicked then go to cart
    // if primary button is set to go to cart else checkout
    if (trigger === 'c') {
      if (theme.isBottomBarButtonActionGoToCart) {
        goToCart({
          isPopup: true,
          isRefreshPageAfterProductAddition: true,
        });
      } else {
        this.props.checkout({
          discountCode: {
            code,
            action: 'checkout',
          },
        });
        logger.log('checkout on skip');
      }
      return;
    }

    let changeAndContinue = true;
    // for upsell continue only if any offered is not added
    // TODO: duplicated logic in minimise, make it common
    if (offerType === 'upsell') {
      const additions = this.getOfferedAdditions();
      const offeredQty = this.getTotalQuantity(additions);
      if (offeredQty > 0) {
        changeAndContinue = false;
      }
    }

    if (changeAndContinue) {
      await changeCartAndContinue(event, variantsWithOldQuantity, trigger);
    }

    if (floatingDisabled) {
      this.closeAll();
    } else {
      this.togglePopup();
    }

    // TODO: check with murtuza that because of this reload cart drawer redirection
    // or cart drawer open will not work
    // if (!isInaEss()) {
    if (reload) {
      logger.log('refresh initiated 567');
      reloadPage();
    }
    // }
  };

  getOfferedAdditions = () => {
    const { products } = this.props;
    const allAdditions = [];
    for (let i = 0; i < products.length; i += 1) {
      const additions = this.getProductAddtionsByProductIndex(i);
      if (additions && additions.length > 0) {
        allAdditions.push(...additions);
      }
    }
    return allAdditions;
  };

  expandPopup = () => {
    if (!this.state.expand) {
      const {
        products,
        theme,
        trigger,
        eventID,
        isTimerDisabled,
        isDiscountDisabled,
        triggerType,
        floatingDisabled,
        offerType,
        currencyFormat,
        discountType,
        discountValue,
        discountQuantity,
        isDiscountQuantityRestricted,
        isDiscountCodeApplicable,
        isNumberOfOfferedProductsRestricted,
        isDisableOfferOnClose,
        isBrandingEnabled,
        priceRoundType,
        discountRoundType,
        offerLevelDiscountQuantity,
      } = this.props;
      const { timer } = this.state;
      expandFloatingOffer(
        products,
        theme,
        timer,
        trigger,
        eventID,
        isTimerDisabled,
        isDiscountDisabled,
        triggerType,
        floatingDisabled,
        offerType,
        currencyFormat,
        discountType,
        discountValue,
        discountQuantity,
        isDiscountQuantityRestricted,
        isNumberOfOfferedProductsRestricted,
        isDiscountCodeApplicable,
        isDisableOfferOnClose,
        isBrandingEnabled,
        priceRoundType,
        discountRoundType,
        offerLevelDiscountQuantity,
      );
    }
    this.togglePopup();
  };

  getIsPdpPopupTrigger = trigger => pdpPopupTriggers.includes(trigger);

  onMinimizeClick = async () => {
    const { showProductDesciption, isMinimizedOnce } = this.state;
    const {
      primary,
      products,
      event,
      variantsWithOldQuantity,
      trigger,
      triggerType,
      offerType,
      floatingDisabled,
    } = this.props;

    const added = this.getAddedProductsForEvent();
    this.props.sendEvent({
      name: EventNameOfferButtonClick,
      action: EventActionMinimize,
      primary,
      added,
      offered: products,
      variables: [
        {
          name: 'page',
          value: showProductDesciption ? 'product' : 'offer',
        },
      ],
    });

    let reload = true;
    // don't reload in case of add to cart trigger as event has to be continued
    if (trigger === 'atc') {
      reload = false;
    }

    // on minimize of checkout popup type don't do anything
    // on minimize of buy now we have to change
    if (this.getIsPdpPopupTrigger(trigger)) {
      let changeAndContinue = true;
      // if upsell change and continue only if nothing added
      if (offerType === 'upsell') {
        const additions = this.getOfferedAdditions();
        const offeredQty = this.getTotalQuantity(additions);
        if (offeredQty > 0) {
          changeAndContinue = false;
        }
      }

      if (changeAndContinue) {
        await changeCartAndContinue(event, variantsWithOldQuantity, trigger);
      }
    }

    if (floatingDisabled) {
      this.closeAll();
    } else {
      this.togglePopup();
    }

    // TODO: check with murtuza that because of this reload cart drawer redirection
    // or cart drawer open will not work
    // if (!isInaEss()) {
    if (reload) {
      logger.log('refresh initiated 711');
      reloadPage();
    }
    // }
  };

  togglePopup = () => {
    this.setState({
      expand: !this.state.expand,
      open: !this.state.open,
      isMinimizedOnce: true,
    });
  };

  addToCartFromDescriptionPage = () => {
    const { selectedVariantInfo, productDescriptionIndex } = this.state;
    const {
      products,
      primary,
      theme: { isProductButtonActionGoToPage },
    } = this.props;
    const variant = selectedVariantInfo[productDescriptionIndex];

    this.addToCart(variant);
    if (isProductButtonActionGoToPage) {
      return;
    }

    this.setState({ showProductDesciption: false });

    const product = products[productDescriptionIndex];
    const additions = this.getProductAddtionsByProductIndex(
      productDescriptionIndex,
    );
    const quantity = this.getTotalQuantity(additions);

    const eventName =
      quantity > 0 ? EventNameQuantityChange : EventNameProductButtonClick;
    const action = quantity > 0 ? EventActionIncrease : EventActionAdd;
    const variable2 =
      product.variants.length > 0 &&
      product.variants[0].title !== 'Default Title'
        ? EventVariableVariant
        : EventVariableDefault;
    const eventProductID = this.getProductIDFromVariantID(products, variant.id);
    this.props.sendEvent({
      name: eventName,
      action,
      primary,
      added: [],
      offered: products,
      variables: [
        {
          name: 'page',
          value: 'product',
        },
        {
          name: 'type',
          value: variable2,
        },
        {
          name: 'sp_product_id',
          value: eventProductID.toString(),
        },
        {
          name: 'sp_variant_id',
          value: variant.id.toString(),
        },
      ],
    });
  };

  onCheckoutClick = async () => {
    const { showProductDesciption } = this.state;

    const {
      event,
      variantsWithOldQuantity,
      trigger,
      primary,
      products,
    } = this.props;
    const added = this.getAddedProductsForEvent();

    this.props.sendEvent({
      name: EventNameOfferButtonClick,
      action: EventActionCheckout,
      primary,
      added,
      offered: products,
      variables: [
        {
          name: 'page',
          value: showProductDesciption ? 'product' : 'offer',
        },
      ],
    });

    this.setState({ isBottomBarButtonActionLoading: true });

    // We have add the primary product when popup closes
    if (this.getIsPdpPopupTrigger(trigger)) {
      await addVariantsWithQuantityToCart({
        variantsWithQuantity: this.props.variantsWithQuantityFromPdp,
        isSkipIntercept: true,
      });
    }

    this.onCheckout({
      discountCode: {
        code: getMrDiscountCode() || '',
        action: 'checkout',
      },
    });
  };

  onCheckout = async ({ discountCode }) => {
    const {
      products,
      offerType,
      theme,
      isDiscountDisabled,
      discountQuantity,
      isDiscountQuantityRestricted,
    } = this.props;
    const {
      showProductDesciption,
      productDescriptionIndex,
      selectedVariantInfo,
    } = this.state;

    const isButtonActionCheckout = !theme.isBottomBarButtonActionGoToCart;

    if (showProductDesciption && offerType != 'bundle') {
      const product = products[productDescriptionIndex];
      const additions = this.getProductAddtionsByProductIndex(
        productDescriptionIndex,
      );
      const quantity = this.getTotalQuantity(additions);
      if (quantity === 0) {
        const { id, off, calculatedDiscountFloat } = selectedVariantInfo[
          productDescriptionIndex
        ];
        await addOfferedVariantsToCart([
          {
            variant_id: id,
            properties: getMonkDiscountProperties({
              isDiscountDisabled: calculatedDiscountFloat <= 0,
              off,
              offerType,
              properties: {},
              discountQuantity,
              isDiscountQuantityRestricted,
              cartDiscountText: theme.cartDiscountText,
            }),
          },
        ]);

        if (isButtonActionCheckout) {
          this.props.checkout({ discountCode });
        } else {
          goToCart({
            isPopup: true,
            isRefreshPageAfterProductAddition: true,
          });
        }
        return;
      }
    }

    if (offerType === 'bundle') {
      const variantsToAdd = await this.getBundleVariantsToAdd({
        products,
        selectedVariantInfo,
        isDiscountDisabled,
        discountQuantity,
        isDiscountQuantityRestricted,
        theme,
      });

      if (variantsToAdd.length > 0) {
        this.productEvent({
          name: EventNameProductButtonClick,
          action: EventActionAdd,
        });

        await addOfferedVariantsToCart(variantsToAdd);
      }

      // disable floating as user has accepted the offer
      setFloating(false);

      if (isButtonActionCheckout) {
        this.props.checkout({ discountCode });
      } else {
        goToCart({
          isPopup: true,
          isRefreshPageAfterProductAddition: true,
        });
      }
      return;
    }

    if (isButtonActionCheckout) {
      this.props.checkout({ discountCode });
    } else {
      goToCart({
        isPopup: true,
        isRefreshPageAfterProductAddition: true,
      });
    }
  };

  async getBundleVariantsToAdd({
    products,
    selectedVariantInfo,
    isDiscountDisabled,
    discountQuantity,
    isDiscountQuantityRestricted,
    theme,
  }) {
    const latestCart = await fetchCart();
    const cart = getMRCartFromShopifyCart(latestCart);

    return products.reduce((acc, product, idx) => {
      // add only those products which are not present in cart
      if (!this.isOfferedProductPresentInCartArgs({ idx, products, cart })) {
        return acc.concat({
          variant_id: selectedVariantInfo[idx].id,
          product_id: product.id,
          properties: getMonkDiscountProperties({
            isDiscountDisabled:
              selectedVariantInfo[idx].calculatedDiscountFloat <= 0,
            off: '',
            offerType: 'bundle',
            properties: {},
            discountQuantity,
            isDiscountQuantityRestricted,
            cartDiscountText: theme.cartDiscountText,
          }),
        });
      }
      return acc;
    }, []);
  }

  getTotalQuantity = productAdditions =>
    productAdditions.reduce((total, current) => total + current.quantity, 0);

  closeFloating = () => {
    const { products, primary } = this.props;
    const { showProductDesciption } = this.state;
    const added = this.getAddedProductsForEvent();

    this.props.sendEvent({
      name: EventNameOfferButtonClick,
      action: EventActionClose,
      primary,
      added,
      offered: products,
      variables: [
        {
          name: 'page',
          value: showProductDesciption ? 'product' : 'offer',
        },
      ],
    });

    this.closeAll();
  };

  closeAll = () => {
    const { isDisableOfferOnClose } = this.props;

    document.querySelector('html').style.overflow = 'auto';
    document.querySelector('body').style.overflow = 'auto';

    // when offer is closed due to no offers then no need to set floating
    // to false as on every page load it will be checked
    // also as the user has not closed so donot disable the product
    if (this.state.open === false && this.state.expand === true) {
      // already closed
    } else {
      if (this.props.products.length !== 0) {
        // disable floating
        setFloating(false);
        // setDisabledProductID(this.props.primary.sp_product_id);
        setFloatingInDisplay(false);

        // const quantity = this.getTotalQuantity(
        //   this.props.home.productAdditions
        // );

        if (isDisableOfferOnClose) {
          // setOffersDisable(this.props.triggerType);
        }
      }
      clearInterval(this.myInterval);
      this.setState({ open: false, expand: true, dialog: false });
      renderInDiv({ close: true });
    }
  };

  displayRepeatSelection(idx, repeatProductAddtion) {
    this.setState({
      repeatSelection: true,
      repeatSelectionIndex: idx,
      repeatProductAddtion,
    });
  }

  onClickRepeat() {
    const { repeatProductAddtion, repeatSelectionIndex } = this.state;
    const { products, primary } = this.props;
    const variant = products[repeatSelectionIndex].variants.find(
      element => element.id == repeatProductAddtion.variant_id,
    );

    this.setState(
      {
        repeatSelection: false,
        repeatProductAddtion: {},
        repeatSelectionIndex: 0,
      },
      () => {
        this.addToCart(variant);
      },
    );

    this.props.sendEvent({
      name: EventNameQuantityChange,
      action: EventActionIncrease,
      primary,
      added: [],
      offered: products,
      variables: [
        {
          name: 'page',
          value: 'offer',
        },
        {
          name: 'type',
          value: EventVariableRepeat,
        },
        {
          name: 'sp_product_id',
          value: products[repeatSelectionIndex].id.toString(),
        },
        {
          name: 'sp_variant_id',
          value: variant.id.toString(),
        },
      ],
    });
  }

  onClickChoose() {
    this.setState({
      repeatSelection: false,
      repeatProductAddtion: {},
      repeatSelectionIndex: 0,
    });
  }

  getProductAddtionsByProductIndex = idx => {
    const { products } = this.props;
    const { id, variants } = products[idx];

    const variantIDs = variants.reduce(
      (items, item) => items.concat(item.id),
      [],
    );
    const productAddtions = this.props.init.productAdditions.default || [];
    const variantAdditions = [];
    for (let i = 0; i < productAddtions.length; i++) {
      if (
        productAddtions[i].product_id === id &&
        variantIDs.includes(productAddtions[i].variant_id)
      ) {
        variantAdditions.push(productAddtions[i]);
      }
    }
    return variantAdditions;
  };

  isCurrProductSelectedInRestrictedOfferedProducts() {
    const {
      cart,
      products,
      isNumberOfOfferedProductsRestricted,
      primary,
    } = this.props;
    const result = _isCurrProductSelectedInRestrictedOfferedProducts({
      cart,
      products,
      getProductAddtionsByProductIndex: this.getProductAddtionsByProductIndex,
      getTotalQuantity: this.getTotalQuantity,
      isNumberOfOfferedProductsRestricted,
      primary,
    });
    this.setState({
      isCurrProductSelectedInRestrictedOfferedProductsResult: result,
    });
  }

  getAddedProductsForEvent() {
    const { products } = this.props;
    const addedProducts = [];
    for (let i = 0; i < products.length; i++) {
      const productAdditions = this.getProductAddtionsByProductIndex(i);
      const quantity = this.getTotalQuantity(productAdditions);
      addedProducts.push({
        product_id: products[i].id,
        quantity,
      });
    }
    return addedProducts;
  }

  pad(num, size) {
    num = num.toString();
    while (num.length < size) num = `0${num}`;
    return num;
  }

  toggleShowDescription = idx => {
    return;
    const middleConEle = document.getElementById('scroll-dialog-description');
    const { scrollTop } = middleConEle;
    const { showProductDesciption } = this.state;
    const { primary, products } = this.props;

    const productItemFooterElement = document.getElementById(
      `product-item-footer-0`,
    );
    const productItemFooterWidth =
      (productItemFooterElement && productItemFooterElement.offsetWidth) || 0;
    const itemAddButtonElement = document.getElementById(`add-button-0`);
    const itemAddButtonWidth =
      (itemAddButtonElement && itemAddButtonElement.offsetWidth) || 0;
    if (
      productItemFooterWidth !== 0 &&
      itemAddButtonWidth !== 0 &&
      productItemFooterWidth / 2 < itemAddButtonWidth
    ) {
      sessionStorage.setItem('isAddButtonExpanded', 'yes');
    }

    this.setState(
      {
        showProductDesciption: !showProductDesciption,
        productDescriptionIndex: idx,
      },
      () => {
        if (this.state.showProductDesciption) {
          this.setState({ middleConEleScrollTop: scrollTop });
          middleConEle.scrollTo(0, 0);
        } else {
          setTimeout(() => {
            middleConEle.scrollTo(0, this.state.middleConEleScrollTop);
          }, 100);
        }
      },
    );

    this.props.sendEvent({
      name: EventNameOfferProductPage,
      action: showProductDesciption ? EventActionBack : EventActionOpen,
      primary,
      added: [],
      offered: products,
      variables: [
        {
          name: 'page',
          value: showProductDesciption ? 'product' : 'offer',
        },
        {
          name: 'type',
          value:
            products[idx].variants.length > 0 &&
            products[idx].title !== 'Default Title'
              ? EventVariableVariant
              : EventVariableDefault,
        },
        {
          name: 'sp_product_id',
          value: products[idx].id.toString(),
        },
      ],
    });
  };

  // events triggered from the product component
  productEvent(eventData) {
    const { name, action, variables } = eventData;
    const { primary, products } = this.props;
    this.props.sendEvent({
      name,
      action,
      primary,
      added: [],
      offered: products,
      variables,
    });
  }

  getProductIDFromVariantID(products, variantID) {
    for (let i = 0; i < products.length; i++) {
      for (let j = 0; j < products[i].variants.length; j++) {
        if (products[i].variants[j].id === variantID) {
          return products[i].id;
        }
      }
    }
    return 0;
  }

  getProductFromVariantID(products, variantID) {
    for (let i = 0; i < products.length; i++) {
      for (let j = 0; j < products[i].variants.length; j++) {
        if (products[i].variants[j].id === variantID) {
          return products[i];
        }
      }
    }
    return {};
  }

  async addToCart(variant) {
    const {
      mrOfferID,
      primary,
      offerType,
      discountQuantity,
      isDiscountQuantityRestricted,
      theme,
      home: { discountCode },
      products,
    } = this.props;
    const { id, off, title } = variant;
    const { isProductButtonActionGoToPage } = theme;
    // for upsell remove the primary product from cart
    if (offerType === 'upsell') {
      await changeCart(primary.sp_variant_id, 0);
    }

    const product = this.getProductFromVariantID(products, id);
    if (isProductButtonActionGoToPage) {
      goToProductPage(product.handle);
      return;
    }

    const properties = getMonkDiscountProperties({
      isDiscountDisabled: variant.calculatedDiscountFloat <= 0,
      off,
      offerType,
      properties: {},
      discountQuantity,
      isDiscountQuantityRestricted,
      cartDiscountText: theme.cartDiscountText,
    });

    this.props.addToCart({
      mrOfferID,
      offerType,
      primary,
      variant,
      properties,
      theme,
      discountCode,
      isEmbedded: false,
      productId: product.id,
      variantId: id,
      productTitle: product.title,
      variantTitle: title,
    });
  }

  calculateDiscountValue = ({ price, offerPrice, discountType }) => {
    const discount = this.round(price - offerPrice);
    let discountDisplayValue = 0;
    if (discountType === 'percentage') {
      discountDisplayValue = (discount / price) * 100;
      discountDisplayValue = this.round(discountDisplayValue);
    } else {
      discountDisplayValue = this.round(discount);
    }
    return discountDisplayValue;
  };

  calculateDiscountForBundle = () => {
    const { priceRoundType, discountRoundType } = this.props;
    const { selectedVariantInfo } = this.state;

    const price = selectedVariantInfo.reduce(
      (acc, curr) => acc + curr.priceFloat,
      0,
    );

    const offerPrice = selectedVariantInfo.reduce(
      (acc, curr) => acc + roundOff(curr.offer_price_float, priceRoundType),
      0,
    );

    const discount = selectedVariantInfo.reduce(
      (acc, curr) =>
        acc + roundOff(curr.calculatedDiscountFloat, discountRoundType),
      0,
    );

    return {
      price: this.round(price),
      discount: this.round(discount),
      offerPrice: this.round(offerPrice),
    };
  };

  round = val => {
    const m = Number((Math.abs(val) * 100).toPrecision(15));
    return (Math.round(m) / 100) * Math.sign(val);
  };

  roundToString = val =>
    parseFloat(val)
      .toFixed(2)
      .replace(/\.0+$/, '');

  getAmountWithCurrency = ({ amount, currencyFormat }) => {
    if (getShop() === 'trauco-estilo-muebles.myshopify.com') {
      return this.getAmountWithCurrencyAndSeparator({
        amount,
        currencyFormat,
        separator: '.',
      });
    }
    return currencyFormat.replaceAll('{{amount}}', this.roundToString(amount));
  };

  getAmountWithCurrencyAndSeparator = ({ amount, currencyFormat, separator }) =>
    currencyFormat.replaceAll(
      '{{amount}}',
      this.getAmountWithSeparator({
        amount: this.roundToString(amount),
        separator,
      }),
    );

  getAmountWithSeparator = ({ amount, separator }) =>
    amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);

  getDiscountDisplay = ({
    discount,
    discountValue,
    discountType,
    currencyFormat,
    currencySymbol,
    productDiscountText,
  }) => {
    let discountDisplay = productDiscountText.replace(
      '{{discount}}',
      currencyFormat
        .replace('{{amount}}', this.roundToString(discount))
        .replace('{{currencySymbol}}', currencySymbol),
    );

    if (discountType === 'percentage') {
      discountDisplay = productDiscountText.replace(
        '{{discount}}',
        `${this.roundToString(discountValue)}%`,
      );
    }
    return discountDisplay;
  };

  isOfferedProductPresentInCart = idx => {
    const { cart, products } = this.props;
    return this.isOfferedProductPresentInCartArgs({ idx, cart, products });
  };

  isOfferedProductPresentInCartArgs = ({ idx, cart, products }) => {
    const offeredProductPresentMap = this.getOfferProductsInCart({
      products,
      cart,
    });
    return offeredProductPresentMap[idx];
  };

  isProductPresentInMrCart = (productID, variants, cart) => {
    const variantsToSearch = variants.reduce(
      (items, item) => items.concat(item.id),
      [],
    );
    return cart.some(
      ele =>
        ele.sp_product_id === productID &&
        variantsToSearch.includes(ele.sp_variant_id),
    );
  };

  getAddedVariantTitleFromCart = idx => {
    const { cart, products } = this.props;
    // return _getAddedVariantTitleFromCart({
    //   idx,
    //   cart,
    //   products,
    //   primary,
    //   productAdditions,
    // });
    return this.getOfferedProductVariantTitleInCart({ products, cart, idx });
  };

  isMaximumProductsAdded = idx => {
    const {
      discountQuantity,
      isDiscountQuantityRestricted,
      isNumberOfOfferedProductsRestricted,
      primary,
    } = this.props;
    const additions = this.getProductAddtionsByProductIndex(idx);
    let quantity = this.getTotalQuantity(additions);

    if (
      _isPrimaryAndOfferedSame({
        productAdditions: additions,
        primary,
      })
    ) {
      quantity -= 1;
    }

    if (isNumberOfOfferedProductsRestricted) {
      if (
        this.state.isCurrProductSelectedInRestrictedOfferedProductsResult ===
        idx
      ) {
        return isDiscountQuantityRestricted && quantity >= discountQuantity;
      }
      return false;
    }

    return isDiscountQuantityRestricted && quantity >= discountQuantity;
  };

  onDiscountCodeUpdate = event => {
    this.props.editDiscountCode({ code: event.target.value });
  };

  onDiscountCodeExpand = () => {
    this.setState({ discountCodeExpanded: true });
  };

  getOfferedProductVariantTitleInCart = ({ products, cart, idx }) => {
    const quantityMap = cart.reduce((curr, item) => {
      const { sp_variant_id, quantity } = item;
      const key = sp_variant_id.toString();
      if (curr[key]) {
        curr[key] += quantity;
      } else {
        curr[key] = quantity;
      }
      return curr;
    }, {});

    const variantTitleMap = {};
    for (let i = 0; i < products.length; i++) {
      const { variants } = products[i];
      for (let j = 0; j < variants.length; j++) {
        const { id, title } = variants[j];
        const key = id.toString();
        if (quantityMap[key] > 0) {
          variantTitleMap[i] = title;
          quantityMap[key]--;
          break;
        }
      }
    }

    if (variantTitleMap[idx]) {
      return variantTitleMap[idx];
    }
    return '';
  };

  getOfferProductsInCart = ({ products, cart }) => {
    const quantityMap = cart.reduce((curr, item) => {
      const { sp_variant_id, quantity } = item;
      const key = sp_variant_id.toString();
      if (curr[key]) {
        curr[key] += quantity;
      } else {
        curr[key] = quantity;
      }
      return curr;
    }, {});

    const productPresentMap = {};
    for (let i = 0; i < products.length; i++) {
      const { variants } = products[i];
      for (let j = 0; j < variants.length; j++) {
        const { id } = variants[j];
        const key = id.toString();
        if (quantityMap[key] > 0) {
          productPresentMap[i] = true;
          quantityMap[key]--;
          break;
        }
      }
    }
    return productPresentMap;
  };

  // TODO: make the code readable, currently added this to change padding for a store
  getHeaderPadding = ({ isTimerDisabled, showProductDesciption }) => {
    if (getShop() === 'hydropeptidedev.myshopify.com') {
      return showProductDesciption
        ? isTimerDisabled
          ? '21px 40px 78px'
          : '21px 40px 72px'
        : isTimerDisabled
          ? '5px 40px'
          : '21px 40px 14px';
    }
    return showProductDesciption
      ? isTimerDisabled
        ? '21px 40px 78px'
        : '21px 40px 72px'
      : isTimerDisabled
        ? '21px 40px'
        : '21px 40px 14px';
  };

  async productClickRedirectionHandler({ idx, isGoToProductPage }) {
    const { products, trigger } = this.props;
    if (isGoToProductPage) {
      // We have add the primary product when popup closes
      if (this.getIsPdpPopupTrigger(trigger)) {
        await addVariantsWithQuantityToCart({
          variantsWithQuantity: this.props.variantsWithQuantityFromPdp,
          isSkipIntercept: true,
        });
      }
      goToProductPage(products[idx].handle);
    }
  }

  onProductImageClick(idx) {
    const { theme } = this.props;
    this.productClickRedirectionHandler({
      idx,
      isGoToProductPage: theme.isProductImageClickGoToPage,
    });
  }

  onProductTitleClick(idx) {
    const { theme } = this.props;
    this.productClickRedirectionHandler({
      idx,
      isGoToProductPage: theme.isProductTitleClickGoToPage,
    });
  }

  isOffTextOnEachBundleVariantEqual = () => {
    const { selectedVariantInfo } = this.state;
    if (!selectedVariantInfo) {
      return false;
    }

    if (selectedVariantInfo.length === 0) {
      return false;
    }

    let sameDiscount = true;
    const { off } = selectedVariantInfo[0];
    for (let i = 0; i < selectedVariantInfo.length; i += 1) {
      if (selectedVariantInfo[i].off !== off) {
        sameDiscount = false;
        break;
      }
    }
    return sameDiscount;
  };

  render() {
    const {
      open,
      timer,
      expand,
      showProductDesciption,
      productDescriptionIndex,
      repeatSelection,
      repeatProductAddtion,
      selectedVariantInfo,
      discountCodeExpanded,
      isBottomBarButtonActionLoading,
      isCurrProductSelectedInRestrictedOfferedProductsResult,
    } = this.state;
    const {
      primary,
      products,
      loadingOffer,
      theme,
      isTimerDisabled,
      isDiscountDisabled,
      trigger,
      offerType,
      triggerType,
      currencyFormat,
      currencySymbol,
      isDiscountCodeApplicable,
      home: { discountCode },
      init: { productAdditions, atcStatus },
      isBrandingEnabled,
      isDiscountQuantityRestricted,
      discountQuantity,
      isNumberOfOfferedProductsRestricted,
      changeCartVartiantWithoutProperties,
      cart,
      discountType,
      discountRoundType,
      offerLevelDiscountQuantity,
      isMobile,
    } = this.props;

    const additions = this.getOfferedAdditions();
    const totalItemsAdded = this.getTotalQuantity(additions);
    const { minutes, seconds } = this.getMinutesAndSeconds(timer);

    const isBundled = offerType === 'bundle';
    const {
      price: bundlePrice,
      offerPrice: bundleOfferPrice,
      discount: bundleDiscount,
    } = this.calculateDiscountForBundle();

    let bundleDiscountValue = this.calculateDiscountValue({
      price: bundlePrice,
      offerPrice: bundleOfferPrice,
      discountType,
    });

    // rounding price by user input
    bundleDiscountValue = roundOff(bundleDiscountValue, discountRoundType);

    let totalOff = this.getDiscountDisplay({
      discount: bundleDiscount,
      discountValue: bundleDiscountValue,
      discountType,
      currencyFormat,
      currencySymbol,
      productDiscountText: theme.productDiscountText,
    });

    // in case the same discount is applied on each variant and it is percentage then
    // the same discount value should be displayed on total as well
    if (isBundled && discountType === 'percentage') {
      const isDiscountSame = this.isOffTextOnEachBundleVariantEqual();
      if (isDiscountSame) {
        totalOff = selectedVariantInfo[0].off;
      }
    }

    const bundleDisplayDiscount = bundleDiscount > 0;
    let bundleDisplayPrice = this.getAmountWithCurrency({
      amount: bundlePrice,
      currencyFormat,
    });
    let bundleDisplayOfferPrice = this.getAmountWithCurrency({
      amount: bundleOfferPrice,
      currencyFormat,
    });

    // add this support globally for all offers
    if (getShop() === 'suprfit-fitness-equipment.myshopify.com') {
      bundleDisplayPrice = bundleDisplayPrice.replace('.', ',');
      bundleDisplayOfferPrice = bundleDisplayOfferPrice.replace('.', ',');
    }

    const mainCtaButtonText = theme
      ? theme.bottomBarButtonText
        ? theme.bottomBarButtonText
        : 'Checkout'
      : 'Checkout';

    const {
      isProductButtonActionGoToPage,
      isProductButtonActionCheckout,
      isProductButtonActionGoToCart,
    } = theme;

    const isButtonActionCheckout = !theme.isBottomBarButtonActionGoToCart;
    // const smallWidth = theme.popupType === 'slideout' || isMobile;
    const centralPopup = theme.popupType === 'central' && !isMobile;
    const dialogFullHeight = !(
      (isBundled && centralPopup) ||
      // (isBundled && isMobile) ||
      (centralPopup && theme.popupDesktopLayoutType === 'fullpage')
    );

    let dialogHeight = centralPopup ? '550px' : '';
    let isMobileFullHeight = false;
    let isHideOfferPrice = false;
    if (
      [
        'hydropeptidedev.myshopify.com',
        'yoga-studio-store.myshopify.com',
      ].includes(getShop())
    ) {
      dialogHeight = '745px';
      isMobileFullHeight = true;
      isHideOfferPrice = true;
    }

    const showBundleDiscountCodeWidget =
      ['artizara-com.myshopify.com', 'hsbali.myshopify.com'].includes(
        getShop(),
      ) &&
      isBundled &&
      isDiscountCodeApplicable &&
      isButtonActionCheckout;

    // const transtionComp = centralPopup ? TransitionUp : TransitionLeft;

    return (
      <>
        {/* check weather to display floating or expanded */}
        <Dialog
          open={expand && open}
          fullWidth
          fullHeight={dialogFullHeight}
          maxWidth={centralPopup ? '770px' : !isMobile ? '440px' : ''}
          maxHeight={dialogHeight}
          isMobileFullHeight={isMobileFullHeight}
          popupType={centralPopup ? 'central' : 'slideout'}
          borderRadius={theme.popupBorderRadius}
          mobileBorderRadius={theme.popupMobileBorderRadius}
          transitionIn={
            centralPopup ? fadeInUp : isMobile ? slideInUp : slideInLeft
          }
          transitionOut={
            centralPopup ? fadeOutDown : isMobile ? slideOutDown : slideOutRight
          }
          isPopupBackdropClickEnabled={theme.isPopupBackdropClickEnabled}
          onBackdropClick={this.onMinimizeClick}
        >
          <Popup
            mrOfferID={this.props.mrOfferID}
            theme={theme}
            selectedVariantInfo={selectedVariantInfo}
            seconds={this.pad(seconds, 2)}
            minutes={this.pad(minutes, 2)}
            isTimerDisabled={isTimerDisabled}
            products={products}
            primary={primary}
            isDiscountDisabled={isDiscountDisabled}
            calculateDiscountAdmin={() => ({})}
            _getProductAddtionsByProductIndex={
              _getProductAddtionsByProductIndex
            }
            _getAddedVariantsToDisplay={_getAddedVariantsToDisplay}
            productAdditions={productAdditions.default || []}
            _isMaximumProductsAdded={_isMaximumProductsAdded}
            isDiscountQuantityRestricted={isDiscountQuantityRestricted}
            discountQuantity={discountQuantity}
            _getTotalQuantity={_getTotalQuantity}
            _getAddedVariantTitleFromCart={_getAddedVariantTitleFromCart}
            cart={cart}
            _getProductQuantity={_getProductQuantity}
            _isPrimaryAndOfferedSame={_isPrimaryAndOfferedSame}
            onSelectVariant={this.onSelectVariant}
            _onAddClick={_onAddClick}
            addToCart={this.addToCart}
            isProductButtonActionGoToPage={isProductButtonActionGoToPage}
            isProductButtonActionCheckout={isProductButtonActionCheckout}
            isProductButtonActionGoToCart={isProductButtonActionGoToCart}
            goToProductPage={goToProductPage}
            productEvent={this.productEvent}
            eventConstants={getEventConstants()}
            _getLastAddedVariant={_getLastAddedVariant}
            getVariantQuantity={_getVariantQuantity}
            _getLastAddition={_getLastAddition}
            onMinimizeClick={this.onMinimizeClick}
            onCheckoutClick={this.onCheckoutClick}
            isBrandingEnabled={isBrandingEnabled}
            onSkipClick={this.skipAndContinue}
            shopURL={getShop()}
            isNumberOfOfferedProductsRestricted={
              isNumberOfOfferedProductsRestricted
            }
            _isCurrProductSelectedInRestrictedOfferedProducts={
              _isCurrProductSelectedInRestrictedOfferedProducts
            }
            getTotalQuantity={this.getTotalQuantity}
            isOfferedProductsRestrictedAndAdded={_isOfferedProductsRestrictedAndAdded(
              {
                productAdditions: productAdditions.default || [],
                getTotalQuantity: this.getTotalQuantity,
                isNumberOfOfferedProductsRestricted,
                primary,
              },
            )}
            changeCartVartiantWithoutProperties={
              changeCartVartiantWithoutProperties
            }
            isBottomBarButtonActionLoading={isBottomBarButtonActionLoading}
            trigger={trigger}
            offerType={offerType}
            triggerType={triggerType}
            isBundled={isBundled}
            showBundleDiscountCodeWidget={showBundleDiscountCodeWidget}
            showCrossSellDiscountCodeWidget={
              isDiscountCodeApplicable &&
              totalItemsAdded > 0 &&
              isButtonActionCheckout
            }
            discountCodeWidgetProps={{
              onApply: code => this.onCheckout({ discountCode: code }),
              isBordered: false,
              theme,
              getDiscountCodeFromApps,
              isInsidePopupWidget: true,
              discountCodeValues: discountCode,
              onDiscountCodeRemove: this.props.removeDiscountCode,
              isSkipShopifyDiscountAPICall: false,
            }}
            bundlePriceBarInfo={{
              tagline: theme.bundleTagline,
              offerPrice: bundleDisplayOfferPrice,
              isDiscountDisabled: !bundleDisplayDiscount,
              price: bundleDisplayPrice,
              off: totalOff,
            }}
            isOfferedProductPresentInCart={this.isOfferedProductPresentInCart}
            onProductImageClick={this.onProductImageClick}
            onProductTitleClick={this.onProductTitleClick}
            offerLevelDiscountQuantity={offerLevelDiscountQuantity}
            atcStatus={atcStatus}
            variantsWithQuantityFromPdp={this.props.variantsWithQuantityFromPdp}
          />
        </Dialog>
        {expand === false && (
          <>
            <FloatingButton
              onExpandPopup={this.expandPopup}
              onCloseFloating={this.closeFloating}
              showOfferIcon={getShop() !== 'stylishpaw-official.myshopify.com'}
              floatingText={theme.floatingText}
              floatingRightPosition={theme.floatingRightPosition}
              floatingBottomPosition={theme.floatingBottomPosition}
              floatingBackgroundColor={theme.floatingBackgroundColor}
              floatingBorderRadius={theme.floatingBorderRadius}
              floatingTextColor={theme.floatingTextColor}
              floatingFontSize={theme.floatingFontSize}
              floatingMobileFontSize={theme.floatingMobileFontSize}
              floatingFontStyle={theme.floatingFontStyle}
              floatingFontWeight={theme.floatingFontWeight}
              floatingTextDecoration={theme.floatingTextDecoration}
              floatingTextAlignment={theme.floatingTextAlignment}
              floatingFontFamily={theme.floatingFontFamily}
              floatingPadding={theme.floatingPadding}
              floatingMargin={theme.floatingMargin}
              floatingHeight={theme.floatingHeight}
              floatingWidth={theme.floatingWidth}
            />
          </>
        )}
      </>
    );
  }
}

HomePage.propTypes = {
  addToCart: PropTypes.func,
  offerLevelDiscountQuantity: PropTypes.number,
  home: PropTypes.object,
  products: PropTypes.array,
  theme: PropTypes.object,
  isMobile: PropTypes.bool,
  variantsWithQuantityFromPdp: PropTypes.array,
  trigger: PropTypes.string,
  init: PropTypes.shape({
    productAdditions: PropTypes.shape({
      default: PropTypes.array,
    }),
  }),
};

export function mapDispatchToProps(dispatch) {
  return {
    addToCart: datapack => {
      dispatch(addToCart(datapack));
    },
    checkout: datapack => {
      dispatch(checkout(datapack));
    },
    balanceProductAddtions: datapack => {
      dispatch(balanceProductAddtions(datapack));
    },
    sendEvent: datapack => {
      dispatch(sendEvent(datapack));
    },
    editDiscountCode: datapack => {
      dispatch(editDiscountCode(datapack));
    },
    removeDiscountCode: datapack => {
      dispatch(removeDiscountCode(datapack));
    },
    commonFunction: datapack => {
      dispatch(commonFunction(datapack));
    },
  };
}

const mapStateToProps = createStructuredSelector({
  home: makeSelectHome(),
  init: makeSelectInit(),
  global: makeSelectGlobal(),
});

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

const withReducer = injectReducer({ key: 'home', reducer });
const withSaga = injectSaga({ key: 'home', saga });

const HomePageComponent = compose(
  withReducer,
  withSaga,
  withConnect,
)(HomePage);

// using wrapper to use hook it required function component
const HomePageWrapper = props => {
  const { isMobile } = useScreenDetector();

  return <HomePageComponent isMobile={isMobile} {...props} />;
};

export default HomePageWrapper;
/* eslint-enable no-nested-ternary */
